function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M114.323,23.777c5.405,0,9.788-5.323,9.788-11.889S122.672,0,114.323,0s-9.788,5.323-9.788,11.889S108.917,23.777,114.323,23.777Z",
  transform: "translate(-95.834)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M41.9,300.578c0-.4,0-.113,0,0Z",
  transform: "translate(-41.895 -258.648)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M308.085,301.85c.005-.11,0-.76,0,0Z",
  transform: "translate(-271.109 -259.607)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M78.861,194.5c-.181-11.438-1.675-14.7-13.106-16.76,0,0-1.609,2.05-5.36,2.05s-5.36-2.05-5.36-2.05c-11.306,2.041-12.891,5.251-13.1,16.389-.017.909-.025.957-.028.852,0,.2,0,.564,0,1.2,0,0,2.721,5.486,18.486,5.486s18.486-5.486,18.486-5.486c0-.41,0-.695,0-.889A7.361,7.361,0,0,1,78.861,194.5Z",
  transform: "translate(-41.906 -153.05)"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.979,
    height: 48.618,
    viewBox: "0 0 36.979 48.618",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.77b36d27.svg";
export { ForwardRef as ReactComponent };